import { boardActions } from "@/action/boardActions";
import { navigationActions } from "@/action/navigationActions";
import type { Action } from "@/action/types";
import { isSessionAlmSynced } from "@/backend/read/BackendReader";
import { isSolutionBacklogBoard } from "@/model/board";
import { useConnectionStore } from "@/store/connection";
import { useUserStore } from "@/store/user";

import { BaseBoard } from "./BaseBoard";

type Backlog = "backlog" | "solution_backlog";

export abstract class BaseBacklogBoard<T extends Backlog> extends BaseBoard<T> {
  get contextActions() {
    return {
      board: {
        syncProgramBacklog: this.syncAction(),
        draw: this.drawAction(),
        kanban: navigationActions.showKanban,
      },
      selection: {
        link: true,
        mirror: true,
        team: !isSolutionBacklogBoard(this.board.type),
        art: isSolutionBacklogBoard(this.board.type),
      },
    };
  }

  syncAction(): Action | undefined {
    if (useUserStore().isAllowed("edit") && isSessionAlmSynced() && useConnectionStore().alm) {
      return boardActions.confirmSyncBacklog;
    }
  }
}
